import { useCallback, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import { useDispatch, useSelector } from 'react-redux';
import { NOTIFICATIONS_TYPE, SOCKET } from '../../../../utils/constans';
import { addNewMessage, setIsReloadJobs, setIsReloadNotifications } from '../../../../redux/notifications/actions';
import { useRouteMatch } from 'react-router-dom';
import { paths } from '../../../../routes';

const Socket = () => {
    const dispatch = useDispatch();
    const jwt = useSelector(state => state.auth.user?.jwt);
    const matchChat = useRouteMatch(paths.chat);
    const matchJobs = useRouteMatch(paths.jobs);

    const refSocket = useRef(null);
    const refMatchChat = useRef(matchChat);
    const refMatchJobs = useRef(matchJobs);

    useEffect(() => {
        refMatchChat.current = matchChat;
    }, [matchChat]);

    const connectSocket = useCallback(
        () => {
            if (jwt && refSocket.current === null) {
                refSocket.current = io(process.env.REACT_APP_API_URL, {
                    path: process.env.REACT_APP_SOCKET_URL,
                    query: {
                        token: jwt
                    }
                });
                refSocket.current.on(SOCKET.NOTIFICATIONS, (notification) => {
                    if (!!refMatchChat.current && notification.type === NOTIFICATIONS_TYPE.CHAT_MESSAGE) {
                        dispatch(addNewMessage(notification));
                    } else {
                        if (
                            !!refMatchJobs.current &&
                            (notification.type === NOTIFICATIONS_TYPE.NEW_APPLICATION || notification.type === NOTIFICATIONS_TYPE.CANCEL_APPLICATION_BY_CANDIDATE)
                        ) {
                            dispatch(setIsReloadJobs(true));
                        }
                        dispatch(setIsReloadNotifications(true));
                    }
                });
            } else {
                refSocket.current && refSocket.current.disconnect();
            }
        },
        [jwt, dispatch]
    );

    useEffect(() => {
        connectSocket();
        return () => refSocket.current && refSocket.current.disconnect();
    }, [connectSocket]);

    return null;
}

export default Socket;